module.exports = __webpack_public_path__ + "static/media/stress.8b0053f7.svg";